// SAT V4 Zone Routes
const satV4Zone = '/sat-v4-zone';

export const routes = {
  base: satV4Zone,
  test: `${satV4Zone}/test`,
  dashboard: `${satV4Zone}/dashboard`,

  // Upload (single page with tabs)
  upload: `${satV4Zone}/upload`,

  // School Structure (single page with tabs)
  schoolStructure: `${satV4Zone}/school-structure`,

  // User Management (page with tabs + sub-pages)
  userManagement: {
    base: `${satV4Zone}/user-management`,
    teacherDetail: `${satV4Zone}/user-management/teacher/:teacherId`,
    pupilDetail: `${satV4Zone}/user-management/pupil/:pupilId`,
  },

  // Rules and Preferences (single page with tabs)
  rulesPreferences: `${satV4Zone}/rules-preferences`,

  // Timetable Management (sidebar sub-menu pages)
  timetable: {
    createTimetable: `${satV4Zone}/timetable/create`,
    subjectOptions: `${satV4Zone}/timetable/subject-options`,
    conflictResolution: `${satV4Zone}/timetable/conflicts`,
    userViews: `${satV4Zone}/timetable/views`,
    export: `${satV4Zone}/timetable/views/export`,
    versionHistory: `${satV4Zone}/timetable/history`,
    analytics: `${satV4Zone}/timetable/analytics`,
  },

  // Settings (single page with tabs)
  settings: `${satV4Zone}/settings`,

  // System routes
  unauthorized: '/403',
  notFound: '/not-found',
};

export function toRelativePath(absolutePath: string, baseName = '/sat-v4-zone'): string {
  let relative = absolutePath;

  if (absolutePath === baseName) return '';

  if (absolutePath.startsWith(baseName)) {
    relative = absolutePath.substring(baseName.length);
  }

  return relative.startsWith('/') ? relative.substring(1) : relative;
}

// Helper to build teacher detail route
export function getTeacherDetailPath(teacherId: string): string {
  return routes.userManagement.teacherDetail.replace(':teacherId', teacherId);
}

// Helper to build pupil detail route
export function getPupilDetailPath(pupilId: string): string {
  return routes.userManagement.pupilDetail.replace(':pupilId', pupilId);
}

export default routes;
